import { API } from 'config';

function SubscriptionService($http, $resource) {

  'ngInject';

  const SubscriptionResource = $resource(API.COMPANY.SUBSCRIPTIONS, { companyId: '@companyId', subscriptionId: '@subscriptionId' }, {
    get: {
      method: 'GET',
    },
    create: {
      method: 'POST',
    },
    cancel: {
      method: 'DELETE',
      url: `${API.COMPANY.SUBSCRIPTIONS}/:subscriptionId`,
    },
  });

  return {
    create: (companyId, plan, monthly) =>
      SubscriptionResource.create({ companyId }, { plan, monthly }).$promise,
    get: (companyId) =>
      SubscriptionResource.get({ companyId }).$promise,
    cancel: (companyId, subscriptionId) =>
      SubscriptionResource.cancel({ companyId, subscriptionId }).$promise,
  };
}

export default SubscriptionService;



// WEBPACK FOOTER //
// ./src/services/Subscription.js